<template>
    <aside id="sidebar_right" class="nano affix has-scrollbar" v-if="show" :class="{'aside-right-open': show}">
        <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

        <div class="panel" style="display: block;">
            <slot name="title">
                <div class="panel-heading" v-if="title">
                    <div class="row">
                        <div class="col-md-10">
                            <span class="panel-title">{{title}}</span>
                        </div>
                        <div class="col-md-2 align-right" v-if="showClose">
                            <button type="button" class="btn btn-xs align-right" v-on:click="close"><span class="fa fa-close"></span></button>
                        </div>
                    </div>
                </div>
            </slot>

            <slot name="content"></slot>

        </div>

    </aside>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    export default {
        destroyed() {
            if (this.show === true) {
                this.$store.commit('template/rightMenuClose');
            }
        },
        components: {Loading},
        props: {
            isLoading: {
                type: Boolean,
                default: false,
            },
            show: {
                type: Boolean,
                default: false,
            },
            showClose: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: '',
            },
        },
        methods: {
            close: function () {
                this.$store.commit('template/rightMenuClose');
                this.$emit('close');
            },
        },
        watch: {
            show: function(value) {
                if (value === true) {
                    this.$emit('open');
                    this.$store.commit('template/rightMenuOpen');
                } else {
                    this.$store.commit('template/rightMenuClose');
                }
            },
        },
    }
</script>
